import { __decorate, __metadata } from "tslib";
import { IsNotEmptyObjectWithLVS, IsUndefinable } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { ValidateNested } from 'class-validator';
import { DEFAULT_LOYALTY_POINTS_GRAMMAR_NUMBER_FORM } from '../constants';
import { MerchantExposeGroup } from '../interface';
import { CreateGrammarNumberFormDto } from './CreateGrammarNumberFormDto';
export class CreateDictionaryDto {
    constructor() {
        this.loyaltyPoints = DEFAULT_LOYALTY_POINTS_GRAMMAR_NUMBER_FORM;
    }
}
__decorate([
    ApiPropertyOptional({ type: () => CreateGrammarNumberFormDto }),
    Expose({
        groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH],
    }),
    IsUndefinable({ groups: [MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsNotEmptyObjectWithLVS({ always: true }),
    ValidateNested({ always: true }),
    Type(() => CreateGrammarNumberFormDto),
    __metadata("design:type", CreateGrammarNumberFormDto)
], CreateDictionaryDto.prototype, "loyaltyPoints", void 0);
//# sourceMappingURL=CreateDictionaryDto.js.map